export const getSelectStartTimeList = (t: any) => {
    return [
        { value: '0', label: t('product.am0Hour') },
        { value: '0.5', label: t('product.am0Hour30Min') },
        { value: '1', label: t('product.am1Hour') },
        { value: '1.5', label: t('product.am1Hour30Min') },
        { value: '2', label: t('product.am2Hour') },
        { value: '2.5', label: t('product.am2Hour30Min') },
        { value: '3', label: t('product.am3Hour') },
        { value: '3.5', label: t('product.am3Hour30Min') },
        { value: '4', label: t('product.am4Hour') },
        { value: '4.5', label: t('product.am4Hour30Min') },
        { value: '5', label: t('product.am5Hour') },
        { value: '5.5', label: t('product.am5Hour30Min') },
        { value: '6', label: t('product.am6Hour') },
        { value: '6.5', label: t('product.am6Hour30Min') },
        { value: '7', label: t('product.am7Hour') },
        { value: '7.5', label: t('product.am7Hour30Min') },
        { value: '8', label: t('product.am8Hour') },
        { value: '8.5', label: t('product.am8Hour30Min') },
        { value: '9', label: t('product.am9Hour') },
        { value: '9.5', label: t('product.am9Hour30Min') },
        { value: '10', label: t('product.am10Hour') },
        { value: '10.5', label: t('product.am10Hour30Min') },
        { value: '11', label: t('product.am11Hour') },
        { value: '11.5', label: t('product.am11Hour30Min') },
        { value: '12', label: t('product.pm12Hour') },
        { value: '12.5', label: t('product.pm12Hour30Min') },
        { value: '13', label: t('product.pm1Hour') },
        { value: '13.5', label: t('product.pm1Hour30Min') },
        { value: '14', label: t('product.pm2Hour') },
        { value: '14.5', label: t('product.pm2Hour30Min') },
        { value: '15', label: t('product.pm3Hour') },
        { value: '15.5', label: t('product.pm3Hour30Min') },
        { value: '16', label: t('product.pm4Hour') },
        { value: '16.5', label: t('product.pm4Hour30Min') },
        { value: '17', label: t('product.pm5Hour') },
        { value: '17.5', label: t('product.pm5Hour30Min') },
        { value: '18', label: t('product.pm6Hour') },
        { value: '18.5', label: t('product.pm6Hour30Min') },
        { value: '19', label: t('product.pm7Hour') },
        { value: '19.5', label: t('product.pm7Hour30Min') },
        { value: '20', label: t('product.pm8Hour') },
        { value: '20.5', label: t('product.pm8Hour30Min') },
        { value: '21', label: t('product.pm9Hour') },
        { value: '21.5', label: t('product.pm9Hour30Min') },
        { value: '22', label: t('product.pm10Hour') },
        { value: '22.5', label: t('product.pm10Hour30Min') },
        { value: '23', label: t('product.pm11Hour') },
        { value: '23.5', label: t('product.pm11Hour30Min') },
    ];
};

export const getSelectEndTimeList = (t: any) => {
    return [...getSelectStartTimeList(t), { value: '24', label: t('product.pm1159Minute') }];
};

export const getSelectMinuteList = () => {
    return [
        { value: '0', label: '00분' },
        { value: '5', label: '05분' },
        { value: '10', label: '10분' },
        { value: '15', label: '15분' },
        { value: '20', label: '20분' },
        { value: '25', label: '25분' },
        { value: '30', label: '30분' },
        { value: '35', label: '35분' },
        { value: '40', label: '40분' },
        { value: '45', label: '45분' },
        { value: '50', label: '50분' },
        { value: '55', label: '55분' },
    ];
};
